import { defineStore } from 'pinia'
import marketAnalyticsApi from '@/api/marketanalytics'
import type { MarketAnalyticsSubscriptionAttributes } from 'common'
import { useUserStore } from './user'
import { coreClient } from '@/api/coreclient'

export const useMarketAnalysisStore = defineStore('marketreport', {
  state: () => ({
    activeSubscriptions: [] as MarketAnalyticsSubscriptionAttributes[],
    activeReport: null as MarketAnalyticsSubscriptionAttributes | null
  }),
  actions: {
    async refreshList() {
      this.activeSubscriptions = await marketAnalyticsApi.list()
    },
    async get(id: number, options?: { logVisit?: boolean }) {
      this.activeReport = null
      return marketAnalyticsApi.get(id, options).then((result) => {
        this.activeReport = result
        return result
      })
    },
    async update(report: MarketAnalyticsSubscriptionAttributes) {
      const data = await marketAnalyticsApi.update(report)
      const existingRecordIndex = this.activeSubscriptions.findIndex((_) => _.id === report.id)
      if (existingRecordIndex > -1 && data) {
        this.activeSubscriptions = [data]
          .concat(this.activeSubscriptions.slice(0, existingRecordIndex))
          .concat(this.activeSubscriptions.slice(existingRecordIndex + 1))
      }
      return data
    },
    async delete(id: number) {
      return marketAnalyticsApi.delete(id).then(() => {
        const index = this.activeSubscriptions.findIndex((_) => _.id === id)
        this.activeSubscriptions.splice(index, 1)
        useUserStore().deleteRecentReport(id.toString())
      })
    },
    async create(report: MarketAnalyticsSubscriptionAttributes) {
      const client = await coreClient()
      return await client.marketAnalytics
        .create(report)
        .then((response) => {
          if (response.data !== null) {
            this.activeSubscriptions = [response.data].concat(this.activeSubscriptions)
            return response.data
          }
          return null
        })
        .catch((e) => {
          console.error(e)
          return null
        })
    }
  }
})
